import type { ApiController } from '@/types/api';
import type { SwatidOperationMode } from '@/constants/swatid';

export function isSwatidController(
  controller: Pick<ApiController, 'model' | 'communicationType'>
): boolean {
  return controller.model === 'SWATID_16' || controller.communicationType === 'mqtt_swatid';
}

/** Normaliza modo backend/dispositivo a valor UI/API POST SWATID */
export function toSwatidMode(mode?: string | null): SwatidOperationMode {
  if (mode === 'manual' || mode === 'local' || mode === 'remota') return mode;
  if (mode === 'remote' || mode === 'remoto') return 'remota';
  return 'manual';
}

/** Control de relés vía API solo en modo remota (backend: remote) */
export function canControlSwatidRelays(mode?: string | null): boolean {
  const normalized = toSwatidMode(mode);
  return normalized === 'remota';
}

export function getSwatidRelayCount(controller: Pick<ApiController, 'relayCount' | 'model'>): number {
  return controller.relayCount ?? (controller.model === 'SWATID_16' ? 16 : 2);
}
